module.exports = __webpack_public_path__ + "img/744.900088bd.jpg";